import React, { useEffect } from 'react';
import { Router } from 'react-router';
import { useDispatch } from 'react-redux';
import AdapterLuxon from '@mui/lab/AdapterLuxon';
import { LicenseInfo } from '@mui/x-license-pro';
import { SnackbarProvider } from '@dash/notistack';
import { ThemeProvider } from '@mui/material/styles';
import { fetchAssetClasses } from 'src/common/store/thunks';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { ReportGenerationProgress } from 'src/features/clients/client/reportsV2/components/ReportGenerationProgress';
import Routes from './Routes';
import history from '../history';
import { theme } from '../themes';
import { Notifier } from '../components/notifications/notifier';
import { ConfirmationServiceProvider, MfaStepUp } from '../common/components/dialogs';
import Navigation from '../features/layout/components/navigation/container';
import './App.css';

LicenseInfo.setLicenseKey('4b0bfa362126c5b3a59c1319a6ec384aT1JERVI6NDE4MzMsRVhQSVJZPTE2ODE1MTI0NzgwMDAsS0VZVkVSU0lPTj0x');

function App(): JSX.Element {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          <SnackbarProvider
            maxSnack={5}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            <Notifier />
            <ReportGenerationProgress />
            <MfaStepUp />
            <ConfirmationServiceProvider>
              <Router history={history}>
                <AppBootstrap />
                <Navigation>
                  <Routes />
                </Navigation>
              </Router>
            </ConfirmationServiceProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;

export function AppBootstrap() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAssetClasses());
    // e.g.: any other bootstap element/enum can be hooked here ...
    // -> dispatch(fetchCurrencies());
    // -> dispatch(fetchMarkets());
  }, [dispatch]);

  return null;
}
